import { combineReducers } from 'redux';
import user from './UserData.js';

export default combineReducers({ user: user });
